import Vue from "vue";
import store from "../store/index.js";
import VueRouter from "vue-router";
import AppComponent from "../components/IndexHome.vue";
import MainPage from "../pages/IndexPage/index.vue";
import Error404Page from "../pages/404Page.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    meta: {
      allowAnonymous: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "login" */ "../pages/LoginPage/Login.vue")
  },
  {
    path: "/forgotPassword",
    name: "ForgotPassword",
    meta: {
      allowAnonymous: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../pages/ForgotPasswordPage/ForgotPassword.vue"
      )
  },
  {
    path: "/setforgotPassword",
    name: "SetForgotPassword",
    meta: {
      allowAnonymous: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../pages/ForgotPasswordPage/SetForgotPassword.vue"
      )
  },
  {
    path: "/changePassword",
    name: "ChangePassword",
    meta: {
      authorize: true,
      justLoggedIn: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../pages/ForgotPasswordPage/ChangePassword.vue"
      )
  },
  {
    path: "/",
    //alias: "/",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: MainPage,
    meta: {
      authorize: true,
      allowedRoles: ["Admin"]
    },
    children: [
      {
        path: "",
        component: AppComponent,
        name: "AppSolicitudes",
        meta: {
          authorize: true,
          allowedRoles: ["Any"]
        }
      },
      {
        path: "/users",
        component: () =>
          import(
            /* webpackChunkName: "users" */ "../components/security/Users.vue"
          ),
        name: "Users",
        meta: {
          authorize: true,
          allowedRoles: ["Any"]
        }
      },
      {
        path: "/roles",
        component: () =>
          import(
            /* webpackChunkName: "security" */ "../components/security/Roles.vue"
          ),
        name: "Roles",
        meta: {
          authorize: true,
          allowedRoles: ["Any"]
        }
      },
      {
        path: "/profiles",
        component: () =>
          import(
            /* webpackChunkName: "security" */ "../components/security/Profiles.vue"
          ),
        name: "Profiles",
        meta: {
          authorize: true,
          allowedRoles: ["Any"]
        }
      },
      {
        path: "/security-params",
        component: () =>
          import(
            /* webpackChunkName: "security" */ "../components/security/SecurityParams.vue"
          ),
        name: "SecurityParams",
        meta: {
          authorize: true,
          allowedRoles: ["Any"]
        }
      },
      {
        path: "/audit",
        component: () =>
          import(
            /* webpackChunkName: "security"  */ "../components/security/AuditPrimeVue.vue"
          ),
        name: "Audit",
        meta: {
          authorize: true,
          allowedRoles: ["Any"]
        }
      },
      {
        path: "/profileUser",
        component: () =>
          import(
            /* webpackChunkName: "users" */ "../components/security/ProfileUser.vue"
          ),
        name: "ProfileUser",
        meta: {
          authorize: true,
          justLoggedIn: true
        }
      },
      {
        path: "/format-types",
        component: () =>
          import(
            /* webpackChunkName: "params" */ "../components/params/FormatTypes.vue"
          ),
        name: "FormatTypes",
        meta: {
          authorize: true,
          allowedRoles: ["Any"]
        }
      },
      {
        path: "/formats",
        component: () =>
          import(
            /* webpackChunkName: "params" */ "../components/params/Formats.vue"
          ),
        name: "Formats",
        meta: {
          authorize: true,
          allowedRoles: ["Any"]
        }
      },
      {
        path: "/dataMaps",
        component: () =>
          import(
            /* webpackChunkName: "params" */ "../components/params/DataMaps.vue"
          ),
        name: "DataMaps",
        meta: {
          authorize: true,
          allowedRoles: ["Any"]
        }
      },
      {
        path: "/printConditions",
        component: () =>
          import(
            /* webpackChunkName: "params" */ "../components/params/PrintConditions.vue"
          ),
        name: "PrintConditions",
        meta: {
          //authorize: true,
          allowAnonymous: true,
          allowedRoles: ["Any"]
        }
      },
      {
        path: "/queues",
        component: () =>
          import(
            /* webpackChunkName: "params" */ "../components/params/Queues.vue"
          ),
        name: "Queues",
        meta: {
          authorize: true,
          allowedRoles: ["Any"]
        }
      },
      {
        path: "/documents",
        component: () =>
          import(
            /* webpackChunkName: "params" */ "../components/params/Documents.vue"
          ),
        name: "Documents",
        meta: {
          authorize: true,
          allowedRoles: ["Any"]
        }
      },
      {
        path: "/packages",
        component: () =>
          import(
            /* webpackChunkName: "params" */ "../components/params/Packages.vue"
          ),
        name: "Packages",
        meta: {
          authorize: true,
          allowedRoles: ["Any"]
        }
      },
      {
        path: "/integrations",
        component: () =>
          import(
            /* webpackChunkName: "params" */ "../components/params/Integrations.vue"
          ),
        name: "Integrations",
        meta: {
          authorize: true,
          allowedRoles: ["Any"]
        }
      },
      {
        path: "/dashboard",
        component: () =>
          import(
            /* webpackChunkName: "params" */ "../components/Dashboard/Dashboard.vue"
          ),
        name: "Dashboard",
        meta: {
          authorize: true,
          allowedRoles: ["Any"]
        }
      }
    ]
  },
  {
    path: "/logout",
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: "/404",
    component: Error404Page,
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: "*",
    redirect: "/404",
    meta: {
      allowAnonymous: true
    }
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
});

/* to, from, next */
router.beforeEach(async (to, from, next) => {
  try {
    if (to.path == "/login") next();
    if (to.path == "logout" || to.path == "/logout") {
      await store.dispatch("logoutUser");
      store.dispatch("logoutActionHandler");
      return;
    }

    let loggedIn = await store.dispatch("validateUserState");
    let menu = await store.dispatch("getUserPermissions");

    var perm = null;
    if (menu != undefined && menu != null && menu.length > 0) {
      perm = menu.find(
        (el) => el.route.toLowerCase() == to.fullPath.toLowerCase()
      );
    }

    if (from.path == "/login" && to.path == "/" && loggedIn) {
      next();
      return;
    }

    //Si la ruta requiere autorización
    if (to.matched.some((x) => x.meta.allowAnonymous === true)) {
      /* Si la ruta está marcada para permitir anónimos continuar. */
      next();
    } else if (to.matched.some((x) => x.meta.authorize == true)) {
      /*Si no se ha iniciado sesión, se redirige al login*/
      if (!loggedIn) {
        next({
          path: "/login",
          params: {
            nextUrl: to.fullPath
          }
        });
      } else {
        /*Se permite la navegación.
         * TODO:
         * Crear AuthService para Revisar los Claims
         * Validar la Ruta /to y ver si el usuario tiene permisos
         */

        var hasPerm = false;
        hasPerm =
          perm && perm.menuPermissions && perm.menuPermissions.length > 0;
        if (to.matched.some((x) => x.meta.justLoggedIn == true)) hasPerm = true;

        if (hasPerm || to.fullPath == "/") next();
        else next("/");
      }
    }
  } catch (error) {
    console.log(error);
  }
});

router.afterEach((to, from) => {
  if (to.path != "/login" && from.path != "/login")
    store.commit("toggleDrawerVisibility", "close");
});

export default router;
